import React, {useState, useEffect} from 'react';
import ReactDOM from 'react-dom';

import Speak from './speak-to-us';
import Arrange from './arrange-a-visit';
import Memberships from './memberships';
import JoinUs from './join-us';
import SpaceEnquiry from './space-enquiry';

import gsap from 'gsap';
import CoWorking from './co-working';

const TAB_CHANGE = 'enquire-tab-change';

const EnquireContent = ({tabs, setSelectedTab}) => {
    return (
        <>
            <h1>ENQUIRE</h1>
            <div className="utils__rowBetween">
                {tabs && tabs.map(({name}, index) => {
                    if (index == 3 || index == 4) return;

                    return (
                        <div key={index} className="nav-item" onClick={() => setSelectedTab(index)}>
                            <a>{name}</a>
                            <div className="item-line__outer">
                                <div className="item-line"></div>
                                <svg id="ui-arrow-head" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.03 9.03">
                                    <defs></defs>
                                    <polyline id="ui-arrow-head-2" className="cls-1"
                                              points=".52 .51 9.52 4.51 .52 8.51"/>
                                </svg>
                            </div>
                        </div>
                    )
                })}
            </div>
        </>
    )
}

const GoBack = ({setSelectedTab, responsive = false}) => {
    return (
        <div className={`nav-item overlay-back ${responsive ? 'overlay-back--responsive' : ''}`}
             onClick={() => setSelectedTab(null)}>
            <a>Go Back</a>
            <div className="item-line__outer">
                <div className="item-line"></div>
                <svg id="ui-arrow-head" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.03 9.03">
                    <defs></defs>
                    <polyline id="ui-arrow-head-2" className="cls-1" points=".52 .51 9.52 4.51 .52 8.51"/>
                </svg>
            </div>
        </div>
    )
}

const Enquire = ({tab = null}) => {
    const tabs = [
        {
            name: 'Speak to us',
            color: 'enquire--blue',
        },
        {
            name: 'Arrange a Visit',
            color: 'enquire--blue',
        },
        {
            name: 'Memberships',
            color: 'enquire--blue',
        },
        {
            name: 'Join Us',
            color: 'enquire--green'
        },
        {
            name: 'Space Enquiry',
            color: 'enquire--white'
        },
        {
            name: 'Co-Working',
            color: 'enquire--blue'
        }
    ];

    const defaultColor = 'enquire--orange';

    const [selectedTab, setSelectedTab] = useState(null);
    const [canGoBack, setCanGoBack] = useState(true);
    const [ officeInformation, setOfficeInformation ] = useState(null);
    const [ params, setParams ] = useState(null);

    useEffect(() => {
        window.addEventListener(TAB_CHANGE, ({ detail }) => {
            const { tab, goBack = true, params } = detail;

            console.log(detail);

            setSelectedTab(tab);
            setCanGoBack(goBack);

            if (detail.hasOwnProperty('office_id')) {
                setOfficeInformation({
                    officeId: detail.office_id,
                    officeName: detail.office_name,
                    officePrice: detail.office_price,
                    officeBuilding: detail.office_building,
                    officeSize: detail.office_size,
                    officeFloor: detail.office_floor,
                    officeDesks: detail.office_desks,
                });
            }

            setParams(params);
        });
    }, []);

    return (
        <div className={`enquire ${selectedTab != null ? tabs[selectedTab]?.color : defaultColor}`}>

                <div id={'enquire-star'} className={`enquire__graphic ${selectedTab === null ? '' : 'hide'}`} ></div>
                <div  className={`enquire__graphic  ${selectedTab === null ? 'hide' : ''}`}  ></div>


            {canGoBack && selectedTab !== null && <GoBack setSelectedTab={setSelectedTab}/>}

            <svg className="enquire-close" xmlns="http://www.w3.org/2000/svg" width="23" height="23" version="1.1"
                 onClick={() => setSelectedTab(null)}>
                <polygon points="0 0, 1 0, 23 23, 22 23"></polygon>
                <polygon points="23 0, 22 0, 0 22, 0 23"></polygon>
            </svg>
            <div className="enquire__inner">
                <div className="equire-top__mobile">
                    <svg className="enquire-close enquire-close__mobile" xmlns="http://www.w3.org/2000/svg" width="23"
                         height="23" version="1.1" onClick={() => setSelectedTab(null)}>
                        <polygon points="0 0, 1 0, 23 23, 22 23"></polygon>
                        <polygon points="23 0, 22 0, 0 22, 0 23"></polygon>
                    </svg>
                    <div className="enquire-top__title">
                        <h1>DMC</h1>
                    </div>
                    {selectedTab != null && <GoBack responsive={true} setSelectedTab={setSelectedTab} params={params}/>}
                </div>

                {selectedTab == null && <EnquireContent tabs={tabs} setSelectedTab={setSelectedTab} params={params}/>}
                {selectedTab == 0 && <Speak setSelectedTab={setSelectedTab} params={params}/>}
                {selectedTab == 1 && <Arrange setSelectedTab={setSelectedTab} params={params}/>}
                {selectedTab == 2 && <Memberships setSelectedTab={setSelectedTab} params={params}/>}
                {selectedTab == 3 && <JoinUs setSelectedTab={setSelectedTab} params={params}/>}
                {selectedTab == 4 && <SpaceEnquiry setSelectedTab={setSelectedTab} { ...officeInformation } params={params}/>}
                {selectedTab == 5 && <CoWorking setSelectedTab={setSelectedTab} params={params}/>}
            </div>
        </div>
    )
}

export default Enquire;

let el = document.getElementById('enquire');

ReactDOM.render(<Enquire/>, el);

const enquireMenu = document.getElementById('enquire');
const enquireClose = document.getElementsByClassName('enquire-close');
const enquireOpen = document.getElementsByClassName('enquire-open');



const joinUsOpen = document.getElementsByClassName('enquire-open-join');

const enquireOpenToggle = () => {
    enquireMenu.classList.add('enquire--toggled');

    gsap.to('#enquire-star', {rotate: 360, ease: 'none', repeat: -1, duration :5});

    const tl = gsap.timeline();

    tl.from(enquireMenu, {xPercent: 100})
        .from('.enquire__inner h1', {xPercent : -5, opacity : 0, duration : 0.5})
        .from('.enquire__inner .nav-item', {yPercent : 20, opacity : 0, duration : 0.5, stagger : 0.2}, 0.2);

    for (const button of enquireClose) {
        button.onclick = () => {
                    enquireMenu.classList.remove('enquire--toggled');

        }
    }
}


for (const button of enquireOpen) {
    button.onclick = () => {
        enquireOpenToggle();
    }
}


export const fireEnquireOpenEvent = (tab, link, params) => {
    const officeId = link?.getAttribute('data-officeId');
    const officeBuilding = link?.getAttribute('data-officeBuilding');
    const officeName = link?.getAttribute('data-officeName');
    const officeFloor = link?.getAttribute('data-officeFloor');
    const officeSize = link?.getAttribute('data-officeSize');
    const officePrice = link?.getAttribute('data-officePrice');
    const officeDesks = link?.getAttribute('data-officeDesks');

    let details = {
        tab: tab,
        goBack: false,
        params: params,
    }

    if (officeId !== null || officeId !== undefined) {
        details.office_id = officeId;
        details.office_building = officeBuilding;
        details.office_name = officeName;
        details.office_floor = officeFloor;
        details.office_size = officeSize;
        details.office_price = officePrice;
        details.office_desks = officeDesks;
    }

    const event = new CustomEvent(TAB_CHANGE, {
        detail: details,
    });

    window.dispatchEvent(event);

    enquireOpenToggle();
}


for (const button of joinUsOpen) {
    button.onclick = () => {
        // I do this event thing here because the component gets rendered once but is toggled via classnames for open and close
        // so changing the tab for the joinUs or any tab instead of having the index as the main page we do it via this
        fireEnquireOpenEvent(3);

    }
}

export function handleLinks(links, tab, params) {
    if (NodeList.prototype.isPrototypeOf(links)) {
        links.forEach(link => {
            link.addEventListener('click', e => {
                e.preventDefault();
                fireEnquireOpenEvent(tab, link, params)
            });
        });
    } else {
        links.addEventListener('click', e => {
            e.preventDefault();
            fireEnquireOpenEvent(tab, links, params)
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    handleLinks(document.querySelectorAll('[href="#co-working"]'), 5);
    handleLinks(document.querySelectorAll('[href="#space-enquiry"]'), 4);
    handleLinks(document.querySelectorAll('[href="#joinus"]'), 3);
    handleLinks(document.querySelectorAll('[href="#memberships"]'), 2);
    handleLinks(document.querySelectorAll('[href="#visit"]'), 1);
    handleLinks(document.querySelectorAll('[href="#enquire"]'), 0);
});



